function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "50%",
  y1: "0%",
  x2: "50%",
  y2: "100%",
  id: "a"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFD700",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFAD00",
  offset: "100%"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.7 22H3.69c-.387.005-.695.262-.689.574.014.66.1 1.321.254 1.968.065.27.358.458.687.458a.963.963 0 0 0 .133-.01c.38-.06.628-.356.555-.662a8.32 8.32 0 0 1-.229-1.773c-.006-.309-.318-.555-.7-.555zM8.175 14.102a10.812 10.812 0 0 0-2.068 1.99 11.3 11.3 0 0 0-2.09 4.23.544.544 0 0 0 .373.661.526.526 0 0 0 .639-.387 10.206 10.206 0 0 1 1.885-3.815 9.836 9.836 0 0 1 1.865-1.797.553.553 0 0 0 .125-.754.508.508 0 0 0-.73-.128zM25 7.056l.241.934 1.552-.848h.035V15H28V6h-1.034z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.904 14.23a.508.508 0 0 0-.73-.128 10.812 10.812 0 0 0-2.067 1.99 11.3 11.3 0 0 0-2.09 4.23.544.544 0 0 0 .373.661.526.526 0 0 0 .639-.387 10.206 10.206 0 0 1 1.885-3.815 9.836 9.836 0 0 1 1.865-1.797.553.553 0 0 0 .125-.754zM3.7 22H3.69c-.387.005-.695.262-.689.574.014.66.1 1.321.254 1.968.065.27.358.458.687.458a.963.963 0 0 0 .133-.01c.38-.06.628-.356.555-.662a8.32 8.32 0 0 1-.229-1.773c-.006-.309-.318-.555-.7-.555zM25 7.056l.241.934 1.552-.848h.035V15H28V6h-1.034z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33.533 0H20.467A3.47 3.47 0 0 0 17 3.466v13.068C17 19.029 18.555 20 20.467 20H33.533A3.47 3.47 0 0 0 37 16.534V3.466A3.47 3.47 0 0 0 33.533 0z",
  fill: "url(#a)",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.858 28.552c-.175-.453-.429-.779-.684-1.068a3.347 3.347 0 0 0-1.22-.779c-1.683-1.155-2.634-2.348-3.301-3.966h-8.967c-1.869 0-4.02-1.732-4.02-3.595l.031-9.822-.053-.007c-.876-.107-1.305-.106-2.176-.015l-.034-.088a3.424 3.424 0 0 0-1.824-1.91 3.438 3.438 0 0 0-2.643-.072A3.434 3.434 0 0 0 5.05 9.05a3.414 3.414 0 0 0-.07 2.636l.028.074C.538 15.145-1.182 21.051.84 26.285l1.967 5.122v.005c.639 1.678.726 3.54.263 5.533a3.13 3.13 0 0 0-.255 2.746l.009.023c.432 1.094 1.753 1.552 2.855 1.132l24.913-9.481c.317-.12.584-.312.803-.543.558-.589.77-1.461.462-2.27zM4.256 24.787a.52.52 0 0 1-.61-.411 10.46 10.46 0 0 1-.188-1.805.52.52 0 0 1 .512-.527h.009a.52.52 0 0 1 .52.51 9.33 9.33 0 0 0 .17 1.625.52.52 0 0 1-.413.608zm4.281-10.163a9.632 9.632 0 0 0-1.855 1.721A9.637 9.637 0 0 0 4.807 20a.52.52 0 0 1-1.006-.263 10.587 10.587 0 0 1 4.135-5.958.517.517 0 1 1 .601.845z",
  fill: "#3B4054",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.881 38l-.957.357-5.956 2.223-.968.362C10.714 42.226 12.098 43 13.564 43c.487 0 .983-.085 1.465-.265l.368-.137a4.015 4.015 0 0 0 2.254-2.071 3.767 3.767 0 0 0 .23-2.527z",
  fill: "#AAAFC3",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M28.476 15H26.5V7.385l-2.358.731V6.51l4.122-1.477h.212z"
}));

var SvgEmptyNotifications = function SvgEmptyNotifications(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 43,
    viewBox: "0 0 37 43",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmptyNotifications, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/EmptyNotifications.73cf10f0.svg";
export { ForwardRef as ReactComponent };